/**
 * Derive the gallery host from the current browser location.
 *
 * The guest PWA is served from the gallery domain itself, so window.location is
 * the canonical source of the host shown in user-facing copy. This avoids
 * hardcoding a domain that differs between dev, interim production, and any
 * future custom domain.
 */

/**
 * @returns {string} the current host, e.g. "wedlinx.catalinx.space" or "localhost:3000"
 */
export function galleryHost() {
  if (typeof window === 'undefined' || !window.location || !window.location.host) {
    return '';
  }
  return window.location.host;
}

/**
 * Build a shareable gallery URL display string.
 * @param {string} [slug] — gallery slug; when omitted/empty returns "{host}/g/"
 * @returns {string} "{host}/g/{slug}" or "{host}/g/", or '' if host unavailable
 */
export function galleryUrlLabel(slug = '') {
  const host = galleryHost();
  if (!host) {
    return '';
  }
  const s = String(slug || '').trim();
  return s ? `${host}/g/${s}` : `${host}/g/`;
}
